const env = process.env.NODE_ENV
var url = 'http://localhost:17072';
// var url = 'http://prizeback.yingxiaozhushou.cn';
const config = {
  development:{
    // baseURL :url//本地
    baseURL :url //线上 
  },
  production:{
     baseURL :'http://prizeback.yingxiaozhushou.cn'
    //  baseURL :'http://localhost:17072'
  }
}
export default {
  baseURL:config[env].baseURL
}